import { useEffect, useState } from 'react';

export default function HappyBag2026Page() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const products = [
    {
      id: 'starter',
      price: '9,999',
      name: '開運スターターBOX',
      limit: '限定88個',
      role: '【浄化・整頓】まずは"場"を整える',
      color: 'from-amber-500 to-yellow-600',
      description: '届いた瞬間から、場が整い始める。総額31,720円相当の豪華グッズ7点セットで、あなたの日常空間を聖なる場へと変容させる入口がここにある。',
      items: [
        { name: '穴口恵子の書籍', price: '1,540円' },
        { name: '心身を癒すセラブオイル', price: '9,000円' },
        { name: '浄化のエプソムソルト', price: '2,200円' },
        { name: '幸運を呼ぶ七福神スプレー', price: '3,800円' },
        { name: '願いを現実にするクリスタルカード', price: '4,180円' },
        { name: '高波動テラヘルツ', price: '5,000円' },
        { name: '輝きを放つ天然クリスタル', price: '6,000円' }
      ],
      image: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/mluzuh2xk988qd3/c3c800809cbf405cb5ccf6e4dd65bd33/original/Gemini_Generated_Image_7ljgec7ljgec7ljg.png'
    },
    {
      id: 'ritual',
      price: '55,555',
      name: '開運リチュアルBOX',
      limit: '限定55個',
      role: '【現実変容】七福神と共に、豊かさの土台を築く',
      color: 'from-red-600 to-rose-700',
      description: '整える、じゃない。この一回で「現実の流れ」が変わる',
      highlight: true,
      activation: '七福神遠隔アクティベーション(通常58,000円)',
      items: [
        { name: '七福神遠隔アクティベーション', price: '58,000円相当' },
        { name: '天然石ブレスレット', price: '22,000円' },
        { name: '豪華福袋グッズ9点セット', price: '63,720円相当' }
      ],
      image: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/mluzuh2xk988qd3/ee499e9f021342a3afba1b7d85026bdd/original/Gemini_Generated_Image_dmv1rwdmv1rwdmv1.png'
    },
    {
      id: 'vip',
      price: '99,999',
      name: 'VIPリチュアルBOX',
      limit: '限定11個',
      role: '【天地統合】七福神 × レインボードラゴンで、次元上昇を果たす',
      color: 'from-purple-700 to-violet-800',
      description: '現実の豊かさも、魂の使命も。2つの巨大なエネルギーを従える。',
      activation: '七福神 + レインボードラゴン覚醒',
      items: [
        { name: '七福神アクティベーション', price: '58,000円相当' },
        { name: 'レインボードラゴン覚醒', price: '55,000円相当' },
        { name: '主役級・高額クリスタル他', price: '豪華グッズ' }
      ],
      image: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/mluzuh2xk988qd3/e3452a5d14804d069a2980eb8c22107c/original/Gemini_Generated_Image_6tpkhx6tpkhx6tpk.png'
    }
  ];

  const galleryImages = [
    'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/height:400/https://cdn.gamma.app/mluzuh2xk988qd3/generated-images/_pXy3Do9dapeRZsflNaef.png',
    'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/height:400/https://cdn.gamma.app/mluzuh2xk988qd3/generated-images/h6jYNHJEsQwVA3CVaOs55.png',
    'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/height:400/https://cdn.gamma.app/mluzuh2xk988qd3/generated-images/kB4iosxmYA-f0mNdy0fgL.png',
    'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/height:400/https://cdn.gamma.app/mluzuh2xk988qd3/generated-images/bbiuDQajcJMopEads8Hxs.png',
    'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/height:400/https://cdn.gamma.app/mluzuh2xk988qd3/generated-images/nxSR0G5cAVmtQ_Kcl_GtQ.png',
    'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/height:400/https://cdn.gamma.app/mluzuh2xk988qd3/generated-images/OLbFx9q8BzFLly2z7ok0E.png',
    'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/height:400/https://cdn.gamma.app/mluzuh2xk988qd3/generated-images/OOkVVt2gVRqFsGi1Ve2Mb.png',
    'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/height:400/https://cdn.gamma.app/mluzuh2xk988qd3/2d533915a3d44b0ea16af3a7ff0ec7c6/original/Gemini_Generated_Image_9f6g5y9f6g5y9f6g.png'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 via-white to-rose-50">
      {/* Hero Section */}
      <section className="relative pt-20 pb-20 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-amber-100/50 via-rose-100/30 to-purple-100/50"></div>
        <div className="max-w-6xl mx-auto relative z-10">
          <div className="text-center mb-12 animate-fade-in">
            <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-amber-600 via-rose-600 to-purple-700 bg-clip-text text-transparent leading-tight">
              穴口恵子
            </h1>
            <h2 className="text-3xl md:text-5xl font-bold mb-8 text-amber-700 leading-tight">
              《開運アクティベーション福袋 2026》
            </h2>
          </div>

          <div className="mb-16">
            <img 
              src="https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/mluzuh2xk988qd3/5d0ece589f1849c596aaf588e14e55f1/original/Ming-Cheng-Wei-She-Dingnotesain-53.png"
              alt="開運アクティベーション福袋 2026"
              className="w-full max-w-4xl mx-auto rounded-2xl shadow-2xl"
            />
          </div>

          <div className="max-w-3xl mx-auto space-y-6 text-center">
            <p className="text-xl md:text-2xl text-gray-700 leading-relaxed italic">
              2026年、あなたは「現実」だけを動かすのか、それとも「魂」の次元まで上昇するのか。
            </p>
            <p className="text-xl md:text-2xl text-gray-700 leading-relaxed italic">
              受け取るか、受け取らないか。すべては、あなたの「決める深さ」次第である。
            </p>
          </div>
        </div>
      </section>

      {/* Message Section */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <img 
                src="https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/mluzuh2xk988qd3/29332743c82a4beba8abfa49d8266f23/original/040801anaguchi025.jpeg"
                alt="穴口恵子"
                className="w-full rounded-2xl shadow-xl"
              />
            </div>
            <div className="order-1 md:order-2 space-y-6">
              <div>
                <p className="text-lg text-gray-600 mb-2">Message from</p>
                <h3 className="text-4xl font-bold text-amber-700 mb-2">穴口恵子</h3>
                <p className="text-xl text-gray-600">Keiko Anaguchi</p>
              </div>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  2026年、新しい時代が始まっている。今年の福袋は、あなたが「どこまで深く受け取るか」を決めるための3つの選択肢をご用意した。まず、日常と場を整えるための9,999縁。次に、「七福神」と共に現実的な豊かさと金運を動かす55,555縁。
                </p>
                <p>
                  そして、「七福神」に加え「レインボードラゴン」と共に魂の使命まで目覚めさせる、究極の99,999縁。特に55,555縁の福袋には、単体で58,000円相当の「七福神遠隔アクティベーション」が入っている。99,999縁には、そこに「レインボードラゴン」のアクティベーションも加わる。2026年、あなたはどのレベルの扉を開くのか。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Choice Section */}
      <section className="py-20 px-4 bg-gradient-to-b from-white to-amber-50">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            運命の<span className="text-amber-700">3つ</span>の選択
          </h2>
          <p className="text-xl text-gray-700 mb-4">
            あなたの魂が求める深さを選び、2026年の運命を決定する時が来た。それぞれの福袋は、
          </p>
          <p className="text-xl text-gray-700 mb-12">
            異なる次元であなたの人生を変容させる力を持っている。
          </p>
          <div className="mt-12">
            <img 
              src="https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/mluzuh2xk988qd3/69bbe16dcde54aed99d69961d1a025d6/original/Gemini_Generated_Image_4a8um4a8um4a8um4.png"
              alt="運命の選択"
              className="w-full max-w-3xl mx-auto rounded-2xl shadow-xl"
            />
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto space-y-20">
          {products.map((product, index) => (
            <div 
              key={product.id}
              className={`bg-gradient-to-br ${product.color} p-1 rounded-3xl shadow-2xl transform hover:scale-[1.02] transition-all duration-300`}
            >
              <div className="bg-white rounded-3xl p-8 md:p-12">
                <div className="text-center mb-8">
                  <h3 className="text-3xl md:text-4xl font-bold mb-3 text-gray-800">
                    {product.price}縁 | {product.name}
                  </h3>
                  <p className="text-lg text-gray-600 mb-4">{product.limit}</p>
                  <p className="text-xl font-semibold text-amber-700 mb-4">{product.role}</p>
                  {product.highlight && (
                    <p className="text-2xl font-bold text-red-600 mb-4">{product.description}</p>
                  )}
                  {!product.highlight && (
                    <p className="text-lg text-gray-700 mb-4">{product.description}</p>
                  )}
                </div>

                <div className="mb-8">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full max-w-2xl mx-auto rounded-xl shadow-lg"
                  />
                </div>

                <div className="grid md:grid-cols-3 gap-6 mb-8">
                  {product.items.map((item, idx) => (
                    <div key={idx} className="bg-gradient-to-br from-gray-50 to-white p-6 rounded-xl border-2 border-gray-100 hover:border-amber-300 transition-colors">
                      <div className={`w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-br ${product.color} text-white text-xl font-bold mb-4 mx-auto`}>
                        {idx + 1}
                      </div>
                      <h4 className="font-bold text-gray-800 mb-2 text-center">{item.name}</h4>
                      <p className="text-sm text-gray-600 text-center">{item.price}</p>
                    </div>
                  ))}
                </div>

                {product.activation && (
                  <div className="bg-gradient-to-r from-amber-50 to-rose-50 p-6 rounded-xl mb-8">
                    <p className="text-center text-lg font-semibold text-gray-800">
                      {product.activation}
                    </p>
                  </div>
                )}

                <div className="text-center">
                  <a 
                    href="https://www.rainbowangels.jp/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`inline-block px-12 py-4 bg-gradient-to-r ${product.color} text-white text-lg font-bold rounded-full hover:shadow-2xl transform hover:scale-105 transition-all whitespace-nowrap cursor-pointer`}
                  >
                    {product.price}縁で購入する
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Activation Details */}
      <section className="py-20 px-4 bg-gradient-to-b from-white to-purple-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">
            コンテンツ & アイテム詳細
          </h2>
          
          <div className="grid md:grid-cols-2 gap-12 mb-16">
            <div className="bg-white p-8 rounded-2xl shadow-xl border-2 border-amber-200">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-amber-500 to-rose-600 text-white text-2xl font-bold rounded-full mb-6 mx-auto">
                <i className="ri-star-fill"></i>
              </div>
              <h3 className="text-2xl font-bold text-center mb-4 text-gray-800">
                七福神遠隔ヒーリング&アクティベーション
              </h3>
              <p className="text-center text-gray-600 mb-6 font-semibold">
                日本の伝統的な金運神様との継続的なコネクション
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                日本の神々があなたのオーラにある「欠乏感」をデトックスし、「富の循環」をインストールする。これだけで通常55,000円で提供されている強力なワークである。金運、商売繁盛、人間関係の調和をもたらす。
              </p>
              <div className="text-center">
                <a 
                  href="http://dynavision-20437018.hs-sites.com/ja/detox24-0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-6 py-3 bg-gradient-to-r from-amber-600 to-rose-600 text-white font-semibold rounded-lg hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                >
                  詳細を見る
                </a>
              </div>
              <img 
                src="https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/mluzuh2xk988qd3/da7e0067998940e0b2ec7c53ecbaf1e1/original/Gemini_Generated_Image_l8tpq9l8tpq9l8tp.png"
                alt="七福神"
                className="w-full rounded-xl mt-6"
              />
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-xl border-2 border-purple-200">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-purple-600 to-violet-700 text-white text-2xl font-bold rounded-full mb-6 mx-auto">
                <i className="ri-dragon-line"></i>
              </div>
              <h3 className="text-2xl font-bold text-center mb-4 text-gray-800">
                レインボードラゴン・マスター
              </h3>
              <p className="text-center text-gray-600 mb-6 font-semibold">
                高次元の存在との繋がり強化
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                7色の光線を持つ龍が、あなたのチャクラを全開にし、高次元のパラレルワールドへと導く。魂の使命を思い出し、無限の可能性へとアクセスする扉が開かれる。VIP限定の究極のアクティベーションである。
              </p>
              <div className="text-center">
                <a 
                  href="https://keikoanaguchi.com/RD24/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-6 py-3 bg-gradient-to-r from-purple-600 to-violet-700 text-white font-semibold rounded-lg hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                >
                  詳細を見る
                </a>
              </div>
              <img 
                src="https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/mluzuh2xk988qd3/0e3012d09e9b435d8303042d30175d93/original/Gemini_Generated_Image_edwon8edwon8edwo.png"
                alt="レインボードラゴン"
                className="w-full rounded-xl mt-6"
              />
            </div>
          </div>

          {/* Gallery */}
          <div className="mb-12">
            <h3 className="text-2xl font-bold text-center mb-8 text-gray-800">厳選グッズの紹介</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {galleryImages.map((img, idx) => (
                <div 
                  key={idx}
                  className="aspect-square rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all cursor-pointer transform hover:scale-105"
                  onClick={() => setSelectedImage(img)}
                >
                  <img 
                    src={img}
                    alt={`グッズ ${idx + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              3つの開運福袋を徹底比較
            </h2>
            <p className="text-lg text-gray-600">
              あなたに最適な福袋を見つけてください
            </p>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full border-collapse bg-white shadow-xl rounded-lg overflow-hidden">
              <thead>
                <tr className="bg-gradient-to-r from-amber-500 to-orange-500">
                  <th className="py-4 px-6 text-left text-white font-bold">項目</th>
                  <th className="py-4 px-6 text-center text-white font-bold">スターターBOX<br />9,999円</th>
                  <th className="py-4 px-6 text-center text-white font-bold bg-rose-600">リチュアルBOX<br />55,555円</th>
                  <th className="py-4 px-6 text-center text-white font-bold">VIP BOX<br />99,999円</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 font-semibold text-gray-800">コンセプト</td>
                  <td className="py-4 px-6 text-center text-gray-700">場を整える基礎</td>
                  <td className="py-4 px-6 text-center text-gray-700 bg-rose-50">七福神と現実変容</td>
                  <td className="py-4 px-6 text-center text-gray-700">天地統合・完全覚醒</td>
                </tr>
                <tr className="border-b border-gray-200 bg-amber-50/30">
                  <td className="py-4 px-6 font-semibold text-gray-800">商品数</td>
                  <td className="py-4 px-6 text-center text-gray-700">約5〜7点</td>
                  <td className="py-4 px-6 text-center text-gray-700 bg-rose-50">約10〜15点</td>
                  <td className="py-4 px-6 text-center text-gray-700">約20点以上</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 font-semibold text-gray-800">総額価値</td>
                  <td className="py-4 px-6 text-center text-gray-700">約30,000円相当</td>
                  <td className="py-4 px-6 text-center text-gray-700 bg-rose-50">約150,000円相当</td>
                  <td className="py-4 px-6 text-center text-gray-700">約300,000円相当</td>
                </tr>
                <tr className="border-b border-gray-200 bg-amber-50/30">
                  <td className="py-4 px-6 font-semibold text-gray-800">特別特典</td>
                  <td className="py-4 px-6 text-center text-gray-700">基本セット</td>
                  <td className="py-4 px-6 text-center text-gray-700 bg-rose-50">七福神グッズ<br />限定アイテム</td>
                  <td className="py-4 px-6 text-center text-gray-700">最高級アイテム<br />完全覚醒セット</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 font-semibold text-gray-800">おすすめの方</td>
                  <td className="py-4 px-6 text-center text-sm text-gray-700">初めての方<br />お試しの方</td>
                  <td className="py-4 px-6 text-center text-sm text-gray-700 bg-rose-50">本格的に<br />開運したい方</td>
                  <td className="py-4 px-6 text-center text-sm text-gray-700">究極の変容を<br />求める方</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="mt-12 text-center">
            <p className="text-lg text-gray-700 leading-relaxed">
              どの福袋も、2026年の開運を強力にサポートする厳選アイテムが詰まっています。<br />
              あなたの目標や予算に合わせてお選びください。
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-b from-amber-50 to-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-8 text-gray-800">
            あなたの運命を選ぶ時が来た
          </h2>
          <p className="text-xl text-gray-700 mb-12 leading-relaxed">
            迷う必要はない。あなたの魂が求める「深さ」を選ぶだけである。グッズで整えるなら、9,999円。七福神と現実を変えるなら、55,555円。龍と共に次元上昇するなら、99,999円。2026年の扉は、あなたの決断を待っている。
          </p>

          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <a 
              href="https://www.rainbowangels.jp/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all cursor-pointer transform hover:scale-105"
            >
              <p className="text-3xl font-bold text-amber-700 mb-2">9,999円</p>
              <p className="text-lg font-semibold text-gray-800 mb-1">スターターBOX</p>
              <p className="text-gray-600">場を整える基礎</p>
            </a>
            <a 
              href="https://www.rainbowangels.jp/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all border-4 border-red-400 cursor-pointer transform hover:scale-105"
            >
              <p className="text-3xl font-bold text-red-700 mb-2">55,555円</p>
              <p className="text-lg font-semibold text-gray-800 mb-1">リチュアルBOX</p>
              <p className="text-gray-600">七福神と現実変容</p>
            </a>
            <a 
              href="https://www.rainbowangels.jp/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all cursor-pointer transform hover:scale-105"
            >
              <p className="text-3xl font-bold text-purple-700 mb-2">99,999円</p>
              <p className="text-lg font-semibold text-gray-800 mb-1">VIP BOX</p>
              <p className="text-gray-600">天地統合・完全覚醒</p>
            </a>
          </div>

          <div className="bg-gradient-to-r from-amber-200 to-rose-200 p-8 rounded-2xl mb-8">
            <p className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
              2026年1月11日 20:00
            </p>
            <p className="text-2xl font-semibold text-gray-700">
              LIVE / OPEN
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-amber-900 to-rose-900 text-white py-12 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-2xl font-bold mb-4">穴口恵子 開運アクティベーション福袋 2026</p>
          <p className="text-amber-200 mb-6">あなたの魂が求める深さを選び、2026年の運命を決定する</p>
          <p className="text-sm text-amber-300">
            © 2026 Keiko Anaguchi. All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Powered by Readdy</a>
          </p>
        </div>
      </footer>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-4xl w-full">
            <button 
              className="absolute -top-12 right-0 text-white text-4xl hover:text-amber-400 transition-colors w-10 h-10 flex items-center justify-center"
              onClick={() => setSelectedImage(null)}
            >
              ×
            </button>
            <img 
              src={selectedImage}
              alt="拡大表示"
              className="w-full h-auto rounded-lg"
            />
          </div>
        </div>
      )}
    </div>
  );
}
